import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=4f631153&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./style.sass?vue&type=style&index=0&id=4f631153&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f631153",
  null
  
)

export default component.exports